$('.setContrast').on('click', function(){
    if ('contrast' in localStorage) {
        localStorage.removeItem('contrast');
        $('.setContrast').removeClass('active');
        $('body').removeClass('bigger-contrast');
    } else {
        $('body').addClass('bigger-contrast');
        $('.setContrast').addClass('active');
        localStorage.setItem('contrast', true);
    }
});

$('document').ready(function(){
    if ('contrast' in localStorage) {
        $('body').addClass('bigger-contrast');
        $('.setContrast').addClass('active');
    } else {
        $('body').removeClass('bigger-contrast');
        $('.setContrast').remove('active');
    }
});




